module.exports = __webpack_public_path__ + "luckycatresort-build/img/404.fe7b497c.svg";